const COLORS = {
  "Approved": "bg-kys-accent text-white",
  "Paid": "bg-green-100 text-green-700",
  "Declined": "bg-red-100 text-red-700",
  "Need More Information": "bg-amber-100 text-amber-700",
  "Quoted": "bg-purple-100 text-purple-700",
  "Completed": "bg-kys-charcoal/10 text-kys-charcoal",
};

export function CustomerStatus({ status, label }) {
  return (
    <span data-testid="request-status" className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-medium ${COLORS[status] || "bg-kys-blush text-kys-accent-dark"}`}>
      {label || status}
    </span>
  );
}
